// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

// The tours.name column is unbounded text and the server applies no cap, so this
// is the only limit in the system. Keep it in one place so the create modal and
// the rename editor agree.
export const MAX_TOUR_NAME_LENGTH = 60;

/** Trims and caps a typed tour name into the value that should be sent. */
export function normalizeTourName(value: string): string {
  return value.trim().slice(0, MAX_TOUR_NAME_LENGTH);
}

/**
 * A tour may not be created without a real name. The server would silently fall
 * back to "Tour" for a blank one, which is how every tour ended up sharing a
 * name — so the check belongs here, before anything is persisted.
 */
export function isValidTourName(value: string): boolean {
  return normalizeTourName(value).length > 0;
}
